export default "__VITE_ASSET__Cxop4zkm__"